import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import UserManagement from "./pages/UserManagement";
import ProjectManagement from "./pages/ProjectManagement";
import RoleManagement from "./pages/RoleManagement";
import PrivateRoute from "./components/PrivateRoute";
import TemplateMailingManagement from "./pages/TemplateMailingManagement";
import TemplateMailingForm from "./pages/TemplateMailingForm";
import ForgotPassword from "./pages/ForgotPassword";
import ConsultationProjectForm from "./pages/ConsultationProjectForm";
import AbaquesManagement from "./pages/AbaquesManagement";
import CatalogManagement from "./pages/CatalogManagement";
import FournisseursManagement from "./pages/FournisseursManagement";
import PlanActionManagement from "./pages/PlanActionManagement";
import { SidebarProvider } from './contexts/SidebarContext';
import DpeManagement from './pages/DpeManagement';

const App: React.FC = () => {

  return (
    <Router>
      <SidebarProvider>
        <Routes>
          <Route path="/login" element={<Login />}  />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<PrivateRoute element={<><Home /></>}  />} />
          <Route path="/home" element={<PrivateRoute element={<><Home /></>} />} />
          {/*<Route path="/prospects" element={<PrivateRoute element={<ProspectManagement />}  />} />*/}

          <Route path="/dpe" element={<PrivateRoute element={<><DpeManagement /></>}  />} />
          <Route path="/projects" element={<PrivateRoute element={<><ProjectManagement /></>}  />} />
          <Route path="/projects/:id" element={<PrivateRoute element={<><ConsultationProjectForm /></>}  />} />
          <Route path="/abaques" element={<PrivateRoute element={<><AbaquesManagement /></>}  />} />
          <Route path="/catalogues" element={<PrivateRoute element={<><CatalogManagement /></>}  />} />
          <Route path="/fournisseurs" element={<PrivateRoute element={<><FournisseursManagement /></>}  />} />
          <Route path="/planactions" element={<PrivateRoute element={<><PlanActionManagement /></>}  />} />

          <Route path="/parametrages/users" element={<PrivateRoute element={<><UserManagement /></>}  />} />
          <Route path="/parametrages/roles" element={<PrivateRoute element={<><RoleManagement /></>}  />} />

          <Route path="/parametrages/template-mailing" element={<PrivateRoute element={<><TemplateMailingManagement/></>}  />} />
          <Route path="/parametrages/template-mailing/create" element={<PrivateRoute element={<><TemplateMailingForm/></>}  />} />
          <Route path="/parametrages/template-mailing/edit/:id" element={<PrivateRoute element={<><TemplateMailingForm/></>}  />} />
        </Routes>
      </SidebarProvider>

    </Router>
  );
};

export default App;
